import { __awaiter, __generator } from "tslib";
import { WebAttribution, isNewCampaign, isNewSession } from '@amplitude/analytics-client-common';
/* eslint-disable @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment */
/**
 * @deprecated
 * This plugin is not used by @amplitude/analytics-browser and
 * is replaced by WebAttribution in @amplitude/analytics-client-common to
 * be able to send identify events before session start.
 */
export var webAttributionPlugin = function (options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var plugin = {
        name: '@amplitude/plugin-web-attribution-browser',
        type: 'before',
        setup: function (config, amplitude) {
            return __awaiter(this, void 0, void 0, function () {
                var webAttribution, pluginConfig, currentCampaign, previousCampaign, isEventInNewSession, campaignEvent;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            webAttribution = new WebAttribution(options, config);
                            return [4 /*yield*/, webAttribution.init()];
                        case 1:
                            _a.sent();
                            pluginConfig = webAttribution.options;
                            currentCampaign = webAttribution.currentCampaign;
                            previousCampaign = webAttribution.previousCampaign;
                            isEventInNewSession = isNewSession(config.sessionTimeout, config.lastEventTime);
                            if (isNewCampaign(currentCampaign, previousCampaign, pluginConfig, config.loggerProvider, isEventInNewSession)) {
                                if (pluginConfig.resetSessionOnNewCampaign) {
                                    amplitude.setSessionId(Date.now());
                                    config.loggerProvider.log('Created a new session for new campaign.');
                                }
                                config.loggerProvider.log('Tracking attribution.');
                                campaignEvent = webAttribution.generateCampaignEvent();
                                amplitude.track(campaignEvent);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        execute: function (event) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, event];
        }); }); },
    };
    return plugin;
};
//# sourceMappingURL=web-attribution.js.map